import s from "./contact-channels138.js";
import t from "./contact-channels137.js";
import o from "./contact-channels126.js";
import n from "./contact-channels139.js";
import { isUndefined as i, isString as m, isNumber as l } from "./contact-channels128.js";
import c from "./contact-channels140.js";
function S(e, f) {
  if (i(e) || e === null)
    return f;
  if (e instanceof s)
    return e;
  if (m(e)) {
    const r = e.toLowerCase();
    return r === "default" ? f : r === "local" || r === "system" ? c.instance : r === "utc" || r === "gmt" ? o.utcInstance : o.parseSpecifier(r) || t.create(e);
  } else return l(e) ? o.instance(e) : typeof e == "object" && "offset" in e && typeof e.offset == "function" ? e : new n(e);
}
export {
  S as normalizeZone
};
//# sourceMappingURL=contact-channels129.js.map
